import { render } from "./B2bFilterButton.vue?vue&type=template&id=d2838a8a&scoped=true&lang=pug"
import script from "./B2bFilterButton.vue?vue&type=script&lang=js"
export * from "./B2bFilterButton.vue?vue&type=script&lang=js"

import "./B2bFilterButton.vue?vue&type=style&index=0&id=d2838a8a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2838a8a"]])

export default __exports__